import React from 'react';
import { Formik } from 'formik';
import { Box, IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { useTranslation } from 'react-i18next';
import { InputField } from '../../../../../components/forms/fields';
import InlineFormWrapper from '../../../../../components/forms/InlineFormWrapper';
import { Typography } from '../../../../../ui-kit';
import { sectionValidationSchema } from './validate';
import { SectionFormProps, SectionFormValues } from './types';

const SectionFormView = ({
    onSubmit,
    count,
    submitText,
    onDelete,
    initialValues = {
        sectionName: '',
    },
}: SectionFormProps) => {
    const { t } = useTranslation();
    return (
        <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            validationSchema={sectionValidationSchema}
        >
            {formikProps => (
                <>
                    <Box display='flex' justifyContent='space-between' alignItems='center'>
                        <Typography variant='subtitle2'>{initialValues.sectionName}</Typography>
                        <IconButton color='secondary' onClick={onDelete}>
                            <DeleteIcon />
                        </IconButton>
                    </Box>
                    <InlineFormWrapper isSubmitting={formikProps.isSubmitting} submitText={submitText}>
                        <InputField<SectionFormValues>
                            margin='none'
                            name="sectionName"
                            label={t('Section Name')}
                            formikProps={formikProps}
                            required
                        />
                    </InlineFormWrapper>
                    <Typography variant='body2'>{t('{{count}} table', { count })}</Typography>
                </>
                )}
        </Formik>
    );
};

export default SectionFormView;
